import { motion } from "motion/react"

import { ProductlaneIcon } from "@productlane/ui"

export function LoadingSlide() {
	return (
		<div className="flex h-32 flex-col items-center">
			<div className="absolute inset-0 flex h-full w-full items-center justify-center">
				<motion.div
					className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#191A1C] ring-1 ring-white/10"
					layoutId="pl-icon"
				>
					<ProductlaneIcon
						fill="white"
						animate={{ scale: 1.1 }}
						transition={{
							repeat: Infinity,
							duration: 0.3,
							repeatType: "reverse",
						}}
						className="h-10"
					/>
				</motion.div>
			</div>
		</div>
	)
}
